import { useMutation, useQuery } from "react-query";

import { Type_Filters } from "src/components/web/FilterElements";
import { Type_Element } from "src/types/element";

import {
    createElement,
    deleteElement,
    getDocumentDetails,
    getDocuments,
    getElements,
    getElementsPerMap,
    updateElement,
} from "./service";

export const mutationCreateElement = () => {
    return useMutation({
        mutationFn: (body: Partial<Type_Element>) => createElement(body),
        onSuccess: async (data) => {
            if (!data?.success || !data) {
                throw new Error("Wrong format data: mutationCreateElement");
            }
        },
        onError: (err: any) => {
            console.debug("ERROR mutationCreateElement", err);
            return err;
        },
    });
};

export const useGetElements = (mapId: number = 1) => {
    return useQuery({
        queryKey: ["elementsByCategories", mapId],
        queryFn: () => {
            return getElements(mapId as number);
        },
        select: (data) => {
            if (!data?.success || !data?.data) {
                throw new Error("Wrong format data: useGetElements");
            }
            return data.data;
        },
        onError: (err: any) => {
            return err;
        },
    });
};

export const useGetElementsPerMap = (
    mapId: number = 1,
    filters: Type_Filters,
) => {
    return useQuery({
        queryKey: ["elements", mapId, filters],
        queryFn: () => {
            return getElementsPerMap(mapId as number, filters);
        },
        select: (data) => {
            if (!data?.success || !data?.data) {
                throw new Error("Wrong format data: useGetElements");
            }
            return data.data;
        },
        onError: (err: any) => {
            return err;
        },
    });
};

export const mutationUpdateElement = () => {
    return useMutation({
        mutationFn: async ({
            elementId,
            body,
        }: {
            elementId: number;
            body: Partial<Type_Element>;
        }) => updateElement(elementId, body),
        onSuccess: async (data) => {
            if (!data?.success || !data) {
                throw new Error("Wrong format data: mutationUpdateElement");
            }
        },
        onError: (err: any) => {
            console.error("Error in mutationUpdateElement:", err);
            return err;
        },
    });
};

export const mutationDeleteElement = () => {
    return useMutation({
        mutationFn: (elementId: number) => deleteElement(elementId),
        onSuccess: async (data) => {
            if (!data?.success || !data) {
                throw new Error("Wrong format data: mutationDeleteElement");
            }
        },
        onError: (err: any) => {
            console.error("Error in mutationDeleteElement:", err);
            return err;
        },
    });
};

export const useGetElementDocuments = (elementId: number) => {
    return useQuery({
        queryKey: ["elementDocuments", elementId],
        queryFn: () => {
            return getDocuments(elementId);
        },
        select: (data) => {
            if (!data?.success || !data?.data) {
                throw new Error("Wrong format data: useGetElementDocuments");
            }
            return data.data;
        },
        onError: (err: any) => {
            return err;
        },
    });
};

export const useGetDocumentDetails = (id: number) => {
    return useQuery({
        queryKey: ["document", id],
        queryFn: () => {
            return getDocumentDetails(id);
        },
        enabled: false,
        select: (data) => {
            if (!data?.success || !data?.data) {
                throw new Error("Wrong format data: useGetDocumentDetails");
            }
            return data.data;
        },
        onError: (err: any) => {
            return err;
        },
    });
};
